<div class="now-decorative-card now-decorative-card-small mb-3">
  <div
    class="content"
    [ngClass]="{ expanded: !collapsed }"
    [attr.aria-hidden]="collapsed"
    [attr.aria-live]="!collapsed ? 'polite' : null"
    aria-atomic="true"
  >
    <ng-content></ng-content>
  </div>
  @if (showCollapseButton) {
    <div class="now-show-more" [ngClass]="{ expanded: !collapsed }">
      <button
        href="#"
        (click)="toggleCollapse($event)"
        type="button"
        class="now-btn now-btn-tertiary now-btn-icon"
        [ngClass]="collapsed ? 'now-icon-caret-down-after' : 'now-icon-caret-up-after'"
        [attr.aria-label]="
          (collapsed ? 'Mehr anzeigen ' : 'Weniger anzeigen ') + collapseButtonText
        "
      >
        {{ collapsed ? 'Mehr anzeigen' : 'Weniger anzeigen' }}
      </button>
    </div>
  }
</div>
